"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadExchangeRatesFail = exports.loadExchangeRatesSuccess = exports.loadExchangeRatesRequest = exports.loadExchangeRateFail = exports.loadExchangeRateSuccess = exports.loadExchangeRateRequest = exports.setValueRangedProduct = exports.setMarketplaceCountryId = exports.clearProducts = exports.loadExchangeProductsFail = exports.loadExchangeProductsSuccess = exports.loadExchangeProductsRequest = exports.loadFiltersFail = exports.loadFiltersSuccess = exports.loadFiltersRequest = exports.loadCampaignFiltersRequest = exports.loadProductFail = exports.loadProductSuccess = exports.loadProductRequest = void 0;

var _marketplace = require("./marketplace.types");

var loadProductRequest = function loadProductRequest(_ref) {
  var productId = _ref.productId,
      giftId = _ref.giftId;
  return {
    type: _marketplace.GIFT_CREATE_LOAD_PRODUCT_REQUEST,
    payload: {
      productId,
      giftId
    }
  };
};

exports.loadProductRequest = loadProductRequest;

var loadProductSuccess = function loadProductSuccess(product) {
  return {
    type: _marketplace.GIFT_CREATE_LOAD_PRODUCT_SUCCESS,
    payload: product
  };
};

exports.loadProductSuccess = loadProductSuccess;

var loadProductFail = function loadProductFail(error) {
  return {
    type: _marketplace.GIFT_CREATE_LOAD_PRODUCT_FAIL,
    payload: error
  };
};

exports.loadProductFail = loadProductFail;

var loadCampaignFiltersRequest = function loadCampaignFiltersRequest(campaignId) {
  return {
    type: _marketplace.GIFT_CREATE_LOAD_CAMPAIGN_MARKETPLACE_FILTERS_REQUEST,
    payload: campaignId
  };
};

exports.loadCampaignFiltersRequest = loadCampaignFiltersRequest;

var loadFiltersRequest = function loadFiltersRequest(giftId) {
  return {
    type: _marketplace.GIFT_CREATE_LOAD_MARKETPLACE_FILTERS_REQUEST,
    payload: giftId
  };
};

exports.loadFiltersRequest = loadFiltersRequest;

var loadFiltersSuccess = function loadFiltersSuccess(filters) {
  return {
    type: _marketplace.GIFT_CREATE_LOAD_MARKETPLACE_FILTERS_SUCCESS,
    payload: filters
  };
};

exports.loadFiltersSuccess = loadFiltersSuccess;

var loadFiltersFail = function loadFiltersFail(error) {
  return {
    type: _marketplace.GIFT_CREATE_LOAD_MARKETPLACE_FILTERS_FAIL,
    payload: error
  };
};

exports.loadFiltersFail = loadFiltersFail;

var loadExchangeProductsRequest = function loadExchangeProductsRequest(_ref2) {
  var id = _ref2.id,
      requestOptions = _ref2.requestOptions;
  return {
    type: _marketplace.GIFT_CREATE_LOAD_EXCHANGE_PRODUCTS_REQUEST,
    payload: {
      id,
      requestOptions
    }
  };
};

exports.loadExchangeProductsRequest = loadExchangeProductsRequest;

var loadExchangeProductsSuccess = function loadExchangeProductsSuccess(products) {
  return {
    type: _marketplace.GIFT_CREATE_LOAD_EXCHANGE_PRODUCTS_SUCCESS,
    payload: products
  };
};

exports.loadExchangeProductsSuccess = loadExchangeProductsSuccess;

var loadExchangeProductsFail = function loadExchangeProductsFail(error) {
  return {
    type: _marketplace.GIFT_CREATE_LOAD_EXCHANGE_PRODUCTS_FAIL,
    payload: error
  };
};

exports.loadExchangeProductsFail = loadExchangeProductsFail;

var clearProducts = function clearProducts() {
  return {
    type: _marketplace.GIFT_CREATE_MARKETPLACE_CLEAR_PRODUCTS
  };
};

exports.clearProducts = clearProducts;

var setMarketplaceCountryId = function setMarketplaceCountryId(countryId) {
  return {
    type: _marketplace.GIFT_CREATE_MARKETPLACE_SET_COUNTRY_ID,
    payload: countryId
  };
};

exports.setMarketplaceCountryId = setMarketplaceCountryId;

var setValueRangedProduct = function setValueRangedProduct(payload) {
  return {
    type: _marketplace.GIFT_SET_RANGED_PRODUCT_PRICE,
    payload
  };
};

exports.setValueRangedProduct = setValueRangedProduct;

var loadExchangeRateRequest = function loadExchangeRateRequest(_ref3) {
  var fromCurrency = _ref3.fromCurrency,
      toCurrency = _ref3.toCurrency,
      value = _ref3.value;
  return {
    type: _marketplace.GIFT_CREATE_CALCULATE_EXCHANGE_REQUEST,
    payload: {
      fromCurrency,
      toCurrency,
      value
    }
  };
};

exports.loadExchangeRateRequest = loadExchangeRateRequest;

var loadExchangeRateSuccess = function loadExchangeRateSuccess(payload) {
  return {
    type: _marketplace.GIFT_CREATE_CALCULATE_EXCHANGE_SUCCESS,
    payload: payload[0].convertedPrice
  };
};

exports.loadExchangeRateSuccess = loadExchangeRateSuccess;

var loadExchangeRateFail = function loadExchangeRateFail(error) {
  return {
    type: _marketplace.GIFT_CREATE_CALCULATE_EXCHANGE_FAIL,
    payload: error
  };
};

exports.loadExchangeRateFail = loadExchangeRateFail;

var loadExchangeRatesRequest = function loadExchangeRatesRequest(payload) {
  return {
    type: _marketplace.GIFT_CREATE_CALCULATE_EXCHANGES_REQUEST,
    payload
  };
};

exports.loadExchangeRatesRequest = loadExchangeRatesRequest;

var loadExchangeRatesSuccess = function loadExchangeRatesSuccess(payload) {
  return {
    type: _marketplace.GIFT_CREATE_CALCULATE_EXCHANGES_SUCCESS,
    payload
  };
};

exports.loadExchangeRatesSuccess = loadExchangeRatesSuccess;

var loadExchangeRatesFail = function loadExchangeRatesFail(error) {
  return {
    type: _marketplace.GIFT_CREATE_CALCULATE_EXCHANGES_FAIL,
    payload: error
  };
};

exports.loadExchangeRatesFail = loadExchangeRatesFail;